import { useSelector } from "react-redux";

function IntroArea() {
  // overall preview state
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );

  return (
    <div className="intro-area">
      <img alt={currentRequest.SKUName} src={currentRequest.DefaultRightPanelImage} />
      {currentRequest.DefaultRightPanelDescription && (
        <div className="intro-area-summary"><div dangerouslySetInnerHTML={{__html: currentRequest.DefaultRightPanelDescription}} /></div>
      )}
    </div>
  );
}

export default IntroArea;
